import React from "react";

export function EmptyState({ icon, title, subtitle, action, testID }) {
  return (
    <div
      data-testid={testID}
      style={{
        display: "flex", flexDirection: "column", alignItems: "center",
        justifyContent: "center", textAlign: "center", padding: "40px 24px",
        gap: 12, minHeight: 320,
      }}
      className="mf-anim-in"
    >
      {icon && <div style={{ opacity: 0.9, marginBottom: 4 }}>{icon}</div>}
      <h3 style={{ margin: 0, fontSize: 20, fontWeight: 800, color: "var(--mf-text)", letterSpacing: -0.3 }}>
        {title}
      </h3>
      {subtitle && (
        <p style={{ margin: 0, fontSize: 14, color: "var(--mf-text-secondary)", maxWidth: 380, lineHeight: 1.5 }}>
          {subtitle}
        </p>
      )}
      {action && <div style={{ marginTop: 12 }}>{action}</div>}
    </div>
  );
}

export function ErrorState({ message, onRetry, testID }) {
  return (
    <div
      data-testid={testID}
      style={{
        padding: "40px 24px", textAlign: "center",
        display: "flex", flexDirection: "column", alignItems: "center", gap: 14,
      }}
    >
      <div style={{ fontSize: 15, color: "var(--mf-text-secondary)" }}>{message}</div>
      {onRetry && (
        <button
          onClick={onRetry}
          data-testid={`${testID}-retry`}
          style={{
            padding: "10px 20px", borderRadius: 999,
            background: "var(--mf-brand)", color: "#fff",
            border: "none", cursor: "pointer", fontWeight: 700, fontSize: 14,
          }}
        >
          Réessayer
        </button>
      )}
    </div>
  );
}
